import React, { useEffect } from "react";
import "./terms.css";
import { Link } from "react-router-dom";

const AccountDeletion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <div className="top-header">
        <div className="header-left">
          <img
            src="/assets/img/InstaTenders - Logo reduced.png"
            alt="InstaTenders Logo"
            className="login-brand-logo"
          />
        </div>
      </div>
      <div className="terms-container">
        <div className="terms-banner">
          <h1>Account Deletion Request</h1>
        </div>

        <div className="terms-card">
          <div className="terms-section">
            <h3>1. Users can delete their account in two ways:</h3>

            <p>
              <strong>a. Inside the Mobile Application</strong>
            </p>
            <ul>
              <li>Go to Profile</li>
              <li>Tap “Delete Account”</li>
              <li>Slide to confirm deletion</li>
            </ul>

            <p>
              <strong>b. By Email Request</strong>
            </p>
            <ul>
              <li>
                Send email to: <strong>support@instatenders.in</strong>
              </li>
              <li>
                Subject: <strong>Account Deletion Request</strong>
              </li>
              <li>Include your registered email ID</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>2. After Deletion Request</h3>
            <ul>
              <li>User account will be permanently deleted</li>
              <li>
                Personal data (email, profile data) will be removed within 7
                business days
              </li>
              <li>
                Certain transaction records may be retained for legal compliance
                if required
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>3. Developer Information</h3>
            <p>
              <strong>Developer:</strong> InstaTenders Solutions Private Limited
            </p>
          </div>
        </div>
      </div>

      <div className="custom-footer">
        <div className="footer-top">
          <div className="footer-col left">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/refund">Refund Policy</Link>
            <Link to="/cancellation">Cancellation Policy</Link>
          </div>

          <div className="footer-col right">
            <p>
              📍 4/159, Thiru.vi.ka Industrial Estate, Labour Colony 1st Street,
              Guindy, Chennai - 600032, Tamil Nadu, India
            </p>
            <p className="phone">📞 +91 9884713801</p>
          </div>
        </div>

        <div className="footer-bottom">
          Copyright © 2026. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;
